import type { DiscountTreeNode as SharedDiscountTreeNode, MediaTargetPath } from 'modules/agreement/discountTree';
import type { SubmissionErrors } from '@ff-it/form';
import type { Activity, ActivityType } from 'types';
import type { Category } from 'modules/supplier/category/types';
import type { Vendor } from 'modules/supplier/vendor/types';
import type { ServiceCategory } from 'modules/supplier/outletOrServiceCategory/types';
import { discountContexts } from 'modules/agreement/discountTree/form';
import type { FactorApplicationPolicy } from 'modules/agreement/factorPolicy/form';

export type ProviderTargetPath = MediaTargetPath;

export type ProviderAgreementDiscountType = { id: ActivityType; label: string };
export type { DiscountContext } from 'modules/agreement/discountTree/form';
export const contexts = discountContexts;
export type ProviderAgreementDiscountRuleInput = {
  /** Full saved chain, ending at the rule's target entity. */
  target_path: ProviderTargetPath;
  terms: string;
  /** Canonical embedded relation returned with the rule. */
  target_category: Category | null;
  /** Canonical embedded relation returned with the rule. */
  target_activity: Activity | null;
  standard_discount: string | null;
  non_standard_discount: string | null;
  package_discount: string | null;
  factor_policy: FactorApplicationPolicy | null;
};
export type ProviderAgreementDiscountRule = ProviderAgreementDiscountRuleInput & {
  id: number;
  order: number;
};
export type ProviderAgreementPartitionRecord = {
  type: ActivityType;
  provided_vendors: readonly { id: number; vendor: Vendor }[];
  provided_service_categories: readonly { id: number; service_category: Pick<ServiceCategory, 'id' | 'name'> }[];
  discount_rates: readonly ProviderAgreementDiscountRule[];
};
export type DiscountTreeNode = SharedDiscountTreeNode<ProviderAgreementDiscountRule>;
export type RuleFormValues = Omit<ProviderAgreementDiscountRuleInput, 'target_path'> & {
  target_path: ProviderTargetPath | null;
};

export type MutationResult = SubmissionErrors | void;
export type RuleMutation = (rule: ProviderAgreementDiscountRuleInput) => Promise<MutationResult>;
